module.exports = __webpack_public_path__ + "img/banner-500-en.bc18562d.png";